import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-4b25a411"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrapper" };
var _hoisted_2 = {
    class: "content",
    style: { overflow: 'hidden' }
};
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { id: "pdf" }, null, -1); });
var _hoisted_4 = [
    _hoisted_3
];
var _hoisted_5 = { class: "overlay-wrapper" };
import { ref, onMounted } from "vue";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default /*#__PURE__*/ _defineComponent({
    __name: 'reviewReport',
    props: {
        title: {
            type: String,
            default: "样本报告详情",
        },
        reportUrl: {
            type: String,
            required: true,
        },
    },
    emits: ["cancel"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var handleCancel = function () {
            sessionStorage.removeItem("reportUrl");
            emit("cancel");
        };
        var loadingVisible = ref(true);
        var pdfh5 = ref();
        if (props.reportUrl) {
            sessionStorage.setItem("reportUrl", props.reportUrl);
        }
        onMounted(function () {
            pdfh5.value = new Pdfh5("#pdf", {
                pdfurl: sessionStorage.getItem("reportUrl"),
                // lazy: true,
                cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/",
            });
            pdfh5.value.on("complete", function () {
                console.log("加载完成");
                loadingVisible.value = false;
            });
        });
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: __props.title,
                    onClickLeft: handleCancel
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }, 8, ["title"]),
                _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [
                    [_vShow, !loadingVisible.value]
                ]),
                _createVNode(_component_van_overlay, {
                    show: loadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
